
    import __i18nConfig from '@next-translate-root/i18n.js'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { Breadcrumb } from "@components/breadcrumb";
import { Products } from "@components/products";
import { PVC } from "@consts/ppvc";
import type { IProduct } from "@type/products";
import { getAllPvcByParent, getAllPvcPathsById, getProductLocaleRedirect, getPvcById, } from "@utils/get-products";
import parse from "html-react-parser";
import type { GetStaticPaths, GetStaticProps, NextPage } from "next/types";
interface IProductCard {
    product: IProduct;
    products: IProduct[];
}
const Product: NextPage<IProductCard> = ({ product, products }) => (<div className="mx-auto max-w-7xl px-4 py-2 sm:px-6 lg:px-8">
    <Breadcrumb product={product?.title}/>
    <h1 className="mb-2 bg-gradient-to-r from-red to-orange p-1 font-bold text-3xl text-white">
      {product?.title}
    </h1>
    <div>{parse(product?.content || "")}</div>
    <hr />
    {products && <Products productPage products={products} showId/>}
  </div>);
export const getStaticPaths: GetStaticPaths = async () => {
    const PATHS_IDS = Object.values(PVC.DOORS);
    const { paths: path } = await getAllPvcPathsById(PATHS_IDS);
    const paths = path.map((p: {
        slug: string;
        databaseId: string;
        language: {
            code: string;
        };
    }) => ({
        locale: p.language.code.toLowerCase(),
        params: {
            slug: `${p.slug}-${p.databaseId}`,
        },
    }));
    return {
        fallback: "blocking",
        paths,
    };
};
const getStaticProps: GetStaticProps = async (context) => {
    const slug = context.params?.slug as string;
    const locale = context.locale ?? "pl";
    const LOCALE = locale === "cz" ? "CS" : locale.toUpperCase();
    const PRODUCT_ID = slug.split("-").pop();
    const { product } = await getPvcById(PRODUCT_ID, LOCALE);
    if (!product) {
        return { notFound: true };
    }
    const redirect = getProductLocaleRedirect(product, LOCALE, "/pvc/doors");
    if (redirect) {
        return { redirect };
    }
    const { products } = await getAllPvcByParent(PVC.DOORS[LOCALE as keyof typeof PVC.DOORS], LOCALE);
    return {
        props: {
            product,
            products,
        },
    };
};
export default Product;

    async function __Next_Translate__getStaticProps__1a19cd2bfa8__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/pvc/doors/[slug]',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../../../locales/' + l + '/' + n).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a19cd2bfa8__ as getStaticProps }
  